import "./scss/import.scss"
import dayjs from "dayjs";
import {initcomponents} from "./components";
import {inithelpers} from "./helpers";

// set up translations
import { useTranslationsStore } from './store/dtranslations'
// set up websocket
import { useWebSocketStore } from './store/dwebsocket'

export function initdod(app, pinia)
{
    // helpers
    inithelpers(app);
    
    // components    
    initcomponents(app);       

    let translations = useTranslationsStore(pinia)    
    translations.fetchTranslationsData();
    dayjs.locale(translations.language)

    let wsstore = useWebSocketStore(pinia)
    wsstore.connect();
}